import React, { PropsWithChildren } from 'react'
import Box from '@mui/material/Box'
import Header from './Header'
import useSx from './sx'

const UsersLayout = ({children}: PropsWithChildren<unknown>) => {
  const sx = useSx()

  return (
    <Box sx={sx.root}>
      <Header />
      {children}
    </Box>
  )
}

export default UsersLayout